import { clearIndexedDbPersistence, Firestore, terminate } from 'firebase/firestore';

/**
 * Drops the local Firestore cache on logout so a shared device never serves a
 * previous user's documents. The instance is unusable afterwards; callers
 * reload the page. Failures (private windows, already-terminated instances)
 * are logged and never block logout.
 */
export async function clearLocalCache(db: Firestore): Promise<void> {
  try {
    await terminate(db);
  } catch (error) {
    console.warn('[firestore] terminate before cache clear failed', error);
  }
  try {
    await clearIndexedDbPersistence(db);
  } catch (error) {
    console.warn('[firestore] could not clear the local cache', error);
  }
}
